import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon } from '@livable/saas-react-components';
import { Button, Typography, Checkbox, MenuItem, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { arrayHaveSameStrings } from 'src/utils/arrayHelpers';
export const GetForm = observer(_ref => {
  var _externalPortfolioIte, _store$homeDashboardS3, _store$homeDashboardS4, _store$homeDashboardS5;
  let callback = _ref.callback,
    newPropertyCallback = _ref.newPropertyCallback,
    externalPortfolioItem = _ref.externalPortfolioItem;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState((_externalPortfolioIte = externalPortfolioItem === null || externalPortfolioItem === void 0 ? void 0 : externalPortfolioItem.properties.map(i => i.id)) !== null && _externalPortfolioIte !== void 0 ? _externalPortfolioIte : []),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPropertyIds = _useState2[0],
    setSelectedPropertyIds = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const getIsConfirmDisabled = () => {
    return selectedPropertyIds.length === 0 || store.portfolios.editPropertyPortfoliosRelationshipAsync.inProgress;
  };
  const confirmMoving = async event => {
    event.stopPropagation();
    event.preventDefault();
    callback({
      action: 'submit',
      data: {
        selectedPropertyIds: selectedPropertyIds,
        portfolioId: externalPortfolioItem === null || externalPortfolioItem === void 0 ? void 0 : externalPortfolioItem.id
      }
    });
  };
  const getIsLoading = () => {
    return store.properties.getPropertiesBatchAsync.inProgress || store.buildings.getBuildingsBatchAsync.inProgress || store.portfolios.editPropertyPortfoliosRelationshipAsync.inProgress;
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    loading: getIsLoading()
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.commonPadding
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.formTitle)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('portfolios_properties_page.select_existing_properties')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    id: "create-new-portfolio-button",
    onClick: () => {
      newPropertyCallback();
    },
    'custom-attribute': '340-AssignPropertiesToPortfolioModal-create-new-portfolio-button'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('portfolios_properties_page.add_new_property')))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "search_for_property",
    name: "search_for_property",
    label: t('portfolios_properties_page.search_for_property'),
    variant: "outlined",
    value: searchKey,
    onChange: event => {
      setSearchKey(event.target.value);
    },
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.portfoliosRadioGroupWrapper)
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: 'portfoliosRadioGroupSelectAll_key',
    value: 'portfoliosRadioGroupSelectAll_id',
    variant: "multiple",
    className: "".concat(classes.portfoliosRadioGroup, " ").concat(classes.portfoliosRadioGroupSelectAll),
    onClick: event => {
      var _store$homeDashboardS;
      event.stopPropagation();
      event.preventDefault();
      if (arrayHaveSameStrings((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.getAllUnicCompanyProperties.map(i => i.id), selectedPropertyIds)) {
        setSelectedPropertyIds([]);
      } else {
        var _store$homeDashboardS2;
        setSelectedPropertyIds([...((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.getAllUnicCompanyProperties.map(i => i.id))]);
      }
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: arrayHaveSameStrings((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.getAllUnicCompanyProperties.map(i => i.id), selectedPropertyIds)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, arrayHaveSameStrings((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.getAllUnicCompanyProperties.map(i => i.id), selectedPropertyIds) ? t('Deselect all') : t('Select all'))), (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.getAllUnicCompanyProperties) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.slice().sort((a, b) => {
    var _ref2;
    return (_ref2 = '' + (a === null || a === void 0 ? void 0 : a.name)) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(b === null || b === void 0 ? void 0 : b.name, undefined, {
      numeric: true
    });
  }).filter(property => {
    var _property$propertyInf;
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat((_property$propertyInf = property.propertyInformation) === null || _property$propertyInf === void 0 || (_property$propertyInf = _property$propertyInf.address) === null || _property$propertyInf === void 0 ? void 0 : _property$propertyInf.addressString).search(searchPhrase) > 0 : true;
  }).map(property => {
    var _property$propertyInf2, _property$propertyInf3, _property$dashboard;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: property.id,
      value: property.id,
      variant: "multiple",
      className: classes.portfoliosRadioGroup,
      selected: selectedPropertyIds.includes(property.id),
      onClick: event => {
        event.stopPropagation();
        event.preventDefault();
        if (selectedPropertyIds.includes(property.id)) {
          setSelectedPropertyIds(selectedPropertyIds.filter(id => id !== property.id));
        } else {
          setSelectedPropertyIds([...selectedPropertyIds, property.id]);
        }
      }
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: selectedPropertyIds.includes(property.id),
      disabled: property.isDefault,
      onChange: () => {
        if (selectedPropertyIds.includes(property.id)) {
          setSelectedPropertyIds(selectedPropertyIds.filter(id => id !== property.id));
        } else {
          setSelectedPropertyIds([...selectedPropertyIds, property.id]);
        }
      }
    }), /*#__PURE__*/React.createElement(Icon, {
      type: "folder-house"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body"
    }, (_property$propertyInf2 = (_property$propertyInf3 = property.propertyInformation) === null || _property$propertyInf3 === void 0 || (_property$propertyInf3 = _property$propertyInf3.address) === null || _property$propertyInf3 === void 0 ? void 0 : _property$propertyInf3.addressString) !== null && _property$propertyInf2 !== void 0 ? _property$propertyInf2 : (_property$dashboard = property.dashboard) === null || _property$dashboard === void 0 ? void 0 : _property$dashboard.propertyAddress));
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      callback({
        action: 'cancel'
      });
    },
    'custom-attribute': '673-new-billing-module-AssignPropertiesToPortfolioModal'
  }, t('buttons.cancel')))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: event => confirmMoving(event),
    disabled: getIsLoading() || getIsConfirmDisabled(),
    'custom-attribute': '674-new-billing-module-AssignPropertiesToPortfolioModal'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getIsLoading()
  }));
});